/**
 * Which KYC record types run out (decided 2026-09-28, migration 620000): a driving licence and a
 * passport. Aadhaar, PAN, a voter ID, a land record or a bank passbook do not, and are saved with no
 * expiry - an invented one would fall due and report the farmer's KYC expired when nothing had.
 * An organisation's KYC requirement can still ask for an expiry on any type; the database holds that.
 */
export const KYC_TYPES_THAT_EXPIRE = ['DRIVING_LICENCE', 'PASSPORT'];

export function kycTypeExpires(valueCode: string | null | undefined): boolean {
  return KYC_TYPES_THAT_EXPIRE.includes(String(valueCode ?? '').toUpperCase());
}
